import { render, staticRenderFns } from "./card.vue?vue&type=template&id=4cbebc5a&scoped=true"
import script from "./card.ts?vue&type=script&lang=ts&external"
export * from "./card.ts?vue&type=script&lang=ts&external"
import style0 from "./card.vue?vue&type=style&index=0&id=4cbebc5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbebc5a",
  null
  
)

export default component.exports